import { FC } from 'react';
import { storageService } from 'infrastructure/services/StorageService';
import { useNavigate } from 'react-router';
import { useContextSelector as useCS } from 'use-context-selector';
import { GlobalConfigContext } from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import * as S from './styled';

interface AuthFormsFooterProps {
  title: string;
  hrefTo?: string;
  hrefText: string;
  remainingTimeToSendCode?: number | undefined;
  setRemainingTimeToSendCode?: React.Dispatch<React.SetStateAction<number>>;
  send?: any;
}

const AuthFormsFooter: FC<AuthFormsFooterProps> = ({
  title,
  hrefTo = '',
  hrefText,
  remainingTimeToSendCode = 0,
  setRemainingTimeToSendCode,
  send,
}) => {
  const navigate = useNavigate();
  const currentEmail: string = useCS(GlobalConfigContext, globalConfigSelectors.currentEmail);

  return (
    <S.FormWrapperFooter component="div">
      <S.FormWrapperFooterText component="p">{title}</S.FormWrapperFooterText>
      {hrefTo && !setRemainingTimeToSendCode && (
        <S.FormWrapperFooterLink
          /* href={hrefTo} */
          onClick={async () => {
            const accessToken = await storageService.getItem('accessToken');
            const refreshToken = await storageService.getItem('refreshToken');
            if (accessToken || refreshToken) {
              await storageService.removeItem('accessToken');
              await storageService.removeItem('refreshToken');
            }
            navigate(hrefTo, { replace: true });
          }}
        >
          {hrefText}
        </S.FormWrapperFooterLink>
      )}
      {!hrefTo && setRemainingTimeToSendCode && remainingTimeToSendCode <= 0 && (
        <S.FormWrapperFooterLink
          onClick={() => {
            send({ email: currentEmail });
            setRemainingTimeToSendCode(60);
          }}
        >
          {hrefText}
        </S.FormWrapperFooterLink>
      )}
      {!hrefTo && setRemainingTimeToSendCode && remainingTimeToSendCode > 0 && (
        <S.FormWrapperFooterResendTimer>
          {hrefText} in {remainingTimeToSendCode}
        </S.FormWrapperFooterResendTimer>
      )}
    </S.FormWrapperFooter>
  );
};

export default AuthFormsFooter;
